<template lang="pug">
ods-main-header(
    :headerLogoText="getCurrentAppTitle"
    logoUrl="/"
    breadcrumbSeparator=">"
    actionsMenuIcon="overflow-menu"
    :showSuitesMenu="true"
    :showBreadcrumbs="true"
    :environment="env"
    :showActionsMenu="false"
    :showUserMenu="true"
    userMenuIcon="user"
    ref="header")

    template(slot="actions")
      header-actions
    //- template(slot="userAvatar")
      ods-icon(icon="ods-icon-user")
    template(slot="user")
      user-menu
    template(slot="suites")
      suites-menu
    //- template(slot="custom")
      header-custom-content
    //- template(slot="notifications")
      header-notifications

</template>

<script>
import HeaderActions from '@/components/header/HeaderActions'
import UserMenu from '@/components/header/UserMenu'
import SuitesMenu from '@/components/header/SuitesMenu'
import HeaderCustomContent from '@/components/header/HeaderCustomContent'
import HeaderNotifications from '@/components/header/HeaderNotifications'
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderContent',
  components: {
    HeaderActions,
    UserMenu,
    SuitesMenu,
    HeaderCustomContent,
    HeaderNotifications
  },

  computed: {
    env () {
      return process.env.ENV_TAG
    },
    ...mapGetters({
      getCurrentAppTitle: 'getCurrentAppTitle'
    })
  },

  methods: {
    handleTopBar (action) {
      if (action) {
        this.$emit('hasTopBar', true)
      } else {
        this.$emit('hasTopBar', false)
      }
    }
  },

  mounted () {
    this.$emit('hasTopBar', this.$refs.header.$slots.topbar)
  }
}
</script>

<style lang="scss" scoped>
  .ods-main-header__client-logo {
    width: 100px;
    img {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
